(function () {
  if (window.__ntHome) return; window.__ntHome = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var cartAddUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';
  var cartUrl = (window.routes && window.routes.cart_url) || '/cart';
  document.documentElement.classList.add('nt-js-root');

  /* ---------- toast ---------- */
  var toast = document.createElement('div');
  toast.className = 'nt nt-toast'; toast.setAttribute('role', 'status'); toast.setAttribute('aria-live', 'polite');
  document.body.appendChild(toast);
  function say(msg) { toast.textContent = msg; toast.classList.add('is-on'); clearTimeout(say.t); say.t = setTimeout(function () { toast.classList.remove('is-on'); }, 2800); }

  /* ---------- progress bar ---------- */
  var prog = document.createElement('div'); prog.className = 'nt nt-progress'; prog.setAttribute('aria-hidden', 'true'); prog.innerHTML = '<span></span>';
  document.body.appendChild(prog);
  var bar = prog.firstChild, ticking = false;
  function onScroll() {
    var h = document.documentElement.scrollHeight - innerHeight;
    bar.style.transform = 'scaleX(' + (h > 0 ? scrollY / h : 0) + ')';
    if (!reduce) document.querySelectorAll('.nt-parallax').forEach(function (el) {
      var r = el.parentElement.getBoundingClientRect(); var mid = r.top + r.height / 2 - innerHeight / 2;
      el.style.transform = 'translate3d(0,' + (mid * -parseFloat(el.dataset.speed || 0.1)).toFixed(1) + 'px,0)';
    });
    ticking = false;
  }
  addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(onScroll); } }, { passive: true });

  /* ---------- cart ---------- */
  function addItems(items, label, btn) {
    if (btn) btn.setAttribute('aria-busy', 'true');
    return fetch(cartAddUrl + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: ['cart-icon-bubble'], sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status) { say(res.description || res.message || 'Could not add to cart'); return; }
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && res.sections && res.sections['cart-icon-bubble']) {
        var tmp = document.createElement('div'); tmp.innerHTML = res.sections['cart-icon-bubble'];
        var inner = tmp.querySelector('.shopify-section'); bubble.innerHTML = inner ? inner.innerHTML : tmp.innerHTML;
      }
      say('Added ' + label + ' to cart — ');
      var a = document.createElement('a'); a.href = cartUrl; a.textContent = 'view cart'; toast.appendChild(a);
    }).catch(function () { say('Could not add to cart'); })
      .finally(function () { if (btn) btn.removeAttribute('aria-busy'); });
  }
  var money = function (cents) { return '$' + (cents / 100).toFixed(2); };

  /* ---------- per-section init (idempotent; re-runs in Theme Editor) ---------- */
  function init(root) {
    root = root || document;
    var io = ('IntersectionObserver' in window && !reduce && !designMode) ? new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }) : null;
    root.querySelectorAll('.nt').forEach(function (s) { s.classList.add('nt-js'); });
    root.querySelectorAll('.nt-stagger').forEach(function (g) { Array.prototype.forEach.call(g.children, function (c, i) { c.style.transitionDelay = (i * 70) + 'ms'; }); });
    root.querySelectorAll('.nt-reveal, .nt-stagger').forEach(function (t) { if (io) io.observe(t); else t.classList.add('is-in'); });

    root.querySelectorAll('.nt-best').forEach(function (sec) {
      if (sec.dataset.ntBound) return; sec.dataset.ntBound = 1;
      var tabs = sec.querySelectorAll('.nt-tab'), panels = sec.querySelectorAll('.nt-tabpanel');
      tabs.forEach(function (t) { t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.classList.toggle('is-active', x === t); x.setAttribute('aria-selected', x === t); });
        panels.forEach(function (p) { p.classList.toggle('is-active', p.dataset.panel === t.dataset.tab); });
      }); });
    });

    root.querySelectorAll('[data-nt-add]').forEach(function (b) {
      if (b.dataset.ntBound) return; b.dataset.ntBound = 1;
      b.addEventListener('click', function () { addItems([{ id: +b.dataset.ntAdd, quantity: 1 }], b.dataset.title || 'item', b); });
    });

    root.querySelectorAll('.nt-bundle').forEach(function (bundle) {
      if (bundle.dataset.ntBound) return; bundle.dataset.ntBound = 1;
      var min = +bundle.dataset.min || 3, pct = +bundle.dataset.pct || 10;
      var boxes = bundle.querySelectorAll('.nt-pick input');
      var meter = bundle.querySelector('.nt-meter');
      meter.innerHTML = new Array(min + 1).join('<span></span>'); meter.style.gridTemplateColumns = 'repeat(' + min + ',1fr)';
      var segs = meter.querySelectorAll('span');
      var lines = bundle.querySelector('[data-lines]'), hint = bundle.querySelector('[data-hint]');
      var sub = bundle.querySelector('[data-sub]'), save = bundle.querySelector('[data-save]'), total = bundle.querySelector('[data-total]');
      var btn = bundle.querySelector('[data-bundle-add]'), btnLabel = btn.querySelector('span'), baseLabel = btnLabel.textContent;
      var shown = { sub: 0, save: 0, total: 0 };
      function tick(el, key, to, neg) {
        var from = shown[key], t0 = performance.now(), d = reduce ? 0 : 450; shown[key] = to;
        (function step(t) { var k = d ? Math.min(1, (t - t0) / d) : 1; el.textContent = (neg ? '−' : '') + money(from + (to - from) * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(step); })(t0);
      }
      function update() {
        var picked = Array.prototype.filter.call(boxes, function (b) { return b.checked; });
        segs.forEach(function (m, i) { m.classList.toggle('on', i < picked.length); });
        lines.innerHTML = picked.length ? picked.map(function (b) { return '<li><span>' + b.dataset.name + '</span><span>' + money(+b.dataset.price) + '</span></li>'; }).join('') : '<li class="is-empty">' + lines.dataset.empty + '</li>';
        var s = picked.reduce(function (a, b) { return a + (+b.dataset.price); }, 0);
        var off = picked.length >= min ? Math.round(s * pct / 100) : 0;
        tick(sub, 'sub', s); tick(save, 'save', off, true); tick(total, 'total', s - off);
        var left = min - picked.length;
        hint.textContent = left > 0 ? ('Add ' + left + ' more to unlock ' + pct + '% off') : (pct + '% off unlocked — nice choice');
        hint.classList.toggle('is-unlocked', left <= 0);
        btn.disabled = picked.length < min;
        btnLabel.textContent = picked.length < min ? baseLabel : ('Add ' + picked.length + ' items · ' + money(s - off));
      }
      boxes.forEach(function (b) { b.addEventListener('change', update); });
      btn.addEventListener('click', function () {
        var items = Array.prototype.filter.call(boxes, function (b) { return b.checked; }).map(function (b) { return { id: +b.value, quantity: 1 }; });
        addItems(items, 'your ' + items.length + '-item bundle', btn);
      });
      update();
    });
    onScroll();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var tab = e.target.closest && e.target.closest('.nt-tabpanel');
    if (tab) { var sec = tab.closest('.nt-best'); var t = sec.querySelector('.nt-tab[data-tab="' + tab.dataset.panel + '"]'); if (t) t.click(); }
  });
})();
